import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import OutputField from "./OutputField";
import PictureCombiner from "./PictureCombiner";
import { getInfoForSelectedCards } from "../../api";
import EditableCardTable from "./EditableCardTable";
import "./MainExport.scss";

const MainExport = () => {
  const location = useLocation();
  const { userCardIds, userId } = location.state;
  const [cards, setCards] = useState(null);

  useEffect(() => {
    const fetchCardInfo = async () => {
      try {
        const cardInfo = await getInfoForSelectedCards(userCardIds);
        console.log('cardInfo',cardInfo)
        setCards(cardInfo);
      } catch (error) {
        console.error("Error fetching card info:", error);
      }
    };
    fetchCardInfo();
  }, [userCardIds]);

  return (
    <section className="grid">
      <div className="contentfront">
        {/* Left Section */}
     
       <div className="export-Editor section-container"> {cards !== null && <EditableCardTable cards={cards} setCards={setCards} />}</div>
        <div className="export-left section-container">
        {cards !== null && <PictureCombiner cards={cards} />}
      
    </div>

    {/* Right Section */}
    <div className="export-right section-container">
      {cards !== null && <OutputField cards={cards} userId={userId} />}
    </div>
      </div>


    </section>
  );
};

export default MainExport;
